import React from 'react'
import './Wcdw.css'
import cep from '../../../../assets/img/cep.svg'
import hd from '../../../../assets/img/hd.svg'
import auor from '../../../../assets/img/auor.svg'
import nti from '../../../../assets/img/nti.svg'
import ct from '../../../../assets/img/ct.svg'
import pds from '../../../../assets/img/pds.svg'
import cefimg from '../../../../assets/img/cef.webp'

function Wcdw() {
    const wcdwlist= [
        {
            id: 0, 
            icon:cep, 
            title:"Internet of Things (IoT)", 
            desc:"Enhance business operations with IoT-enabled apps. Our professional IoT developers provide consulting services to help you leverage IoT's power for secure and efficient growth.",
            img:cefimg
        },
        {
            id: 1, 
            icon:hd, 
            title:"Blockchain", 
            desc:"We offer blockchain app development services tailored to your project's specifications, ensuring secure and decentralized databases. Our end-to-end testing and quality assurance services guarantee timely and budget-compliant app development."
        },
        {
            id: 2, 
            icon:auor, 
            title:"AI/ML", 
            desc:"Integrate advanced AI/ML features like face recognition and predictive modeling into your apps. Our expertise in AI helps automate workflows and improve operations for modern businesses."
        },
        {
            id: 3, 
            icon:nti, 
            title:"Cloud Computing", 
            desc:"Increase scalability, security, and connectivity with cloud computing technology. We offer end-to-end cloud-managed services, including deployment, custom development, data migration, and testing."
        },
        {
            id: 4, 
            icon:ct, 
            title:"AR/VR", 
            desc:"Create immersive experiences for Gen-Z users with high-end AR/VR apps. Our experts deliver scalable AR/VR applications with advanced features, transforming your vision into reality."
        },
        {
            id: 5, 
            icon:pds, 
            title:"Metaverse", 
            desc:"Develop engaging metaverse applications with our experienced developers. Our 3D modeling services and business-focused metaverse technologies help you create limitless business opportunities and achieve seamless growth."
        },
    ]

  return (
    <section className='wcdw-sec'>
        <div className='container'>
            <h3>What Do We Offer?</h3>
            <h5>Cutting-Edge Technologies for Modern Apps</h5>
            <ul>
                {
                    wcdwlist.map((Wcdw, index)=>(
                        <li>
                        <h4><span className='wgbs-icon'><img src={Wcdw.icon} alt=''/></span> <span className='wgbs-head'>{Wcdw.title}</span></h4> 
                        <p>{Wcdw.desc}</p>
                        {/*<div className='wcdw-img'><img src={Wcdw.img} alt=''/></div> */}  
                      </li>
                    ))
                }
                 
            </ul> 
        </div>

      </section>
  )
}

export default Wcdw
